const HomeProjects = [
  {
    id: 1,
    name: "Diva Store",
    url: "https://divastoree.com/",
    image: "images/project-14.png",
    tech: ["React.js", "Api Integeration", "TailwindCSS"],
  },
  {
    id: 2,
    name: "Youtube Clone",
    url: "https://youtube-clone-coral-gamma.vercel.app/",
    image: "images/project-02.png",
    tech: ["Next.js", "Typescript", "TailwindCSS"],
  },
  {
    id: 3,
    name: "Cars Showcase",
    url: "https://car-showcase-zeta-one.vercel.app/",
    image: "images/project-00.png",
    tech: ["Next.js", "Typescript", "TailwindCSS"],
  },
  {
    id: 4,
    name: "Article Summary",
    url: "https://article-summary-pied.vercel.app/",
    image: "images/project-01.png",
    tech: ["Next.js", "Typescript", "TailwindCSS"],
  },
];

const PortfolioProjects = [
  {
    id: 0,
    name: "Diva Store",
    url: "https://divastoree.com/",
    image: "images/project-14.png",
    tech: ["React.js", "Api Integeration", "TailwindCSS"],
  },
  {
    id: 1,
    name: "Youtube Clone",
    url: "https://youtube-clone-coral-gamma.vercel.app/",
    image: "images/project-02.png",
    tech: ["React.js", "MaterialUI"],
  },
  {
    id: 2,
    name: "Article Summary",
    url: "https://article-summary-pied.vercel.app/",
    image: "images/project-01.png",
    tech: ["Next.js", "Typescript", "TailwindCSS"],
  },
  {
    id: 3,
    name: "Cars Showcase",
    url: "https://car-showcase-zeta-one.vercel.app/",
    image: "images/project-00.png",
    tech: ["Next.js", "Typescript", "TailwindCSS"],
  },
  {
    id: 4,
    name: "Food Delivery",
    url: "https://food-delivery-beta-six.vercel.app/",
    image: "images/project-13.png",
    tech: ["React.js", "Context API"],
  },
  {
    id: 5,
    name: "Currency Converter",
    url: "https://currency-converter-bay-mu.vercel.app/",
    image: "images/project-12.png",
    tech: ["React.js"],
  },
  {
    id: 6,
    name: "Starred Github Repos",
    url: "https://starred-github-repos-one.vercel.app/",
    image: "images/project-04.png",
    tech: ["React.js"],
  },
  {
    id: 7,
    name: "myReads",
    url: "https://myreads-books.vercel.app/",
    image: "images/project-03.png",
    tech: ["React.js"],
  },
  {
    id: 8,
    name: "Shopping Cart",
    url: "https://shopping-cart-gold-two.vercel.app/",
    image: "images/project-05.png",
    tech: ["Vanilla JavaScript"],
  },
  {
    id: 9,
    name: "Dips",
    url: "https://mahmoudsafaya.github.io/Dips/",
    image: "images/project-06.png",
  },
  {
    id: 10,
    name: "News Blog",
    url: "https://mahmoudsafaya.github.io/otaku/",
    image: "images/project-07.png",
  },
  {
    id: 11,
    name: "Restaurant",
    url: "https://mahmoudsafaya.github.io/Crazy_Resturant/",
    image: "images/project-08.png",
  },
  {
    id: 12,
    name: "Save A Link",
    url: "https://save-link-bice.vercel.app/",
    image: "images/project-09.png",
  },
  {
    id: 13,
    name: "Weather",
    url: "https://mahmoudsafaya.github.io/weather/",
    image: "images/project-10.png",
  },
  {
    id: 14,
    name: "Red Store",
    url: "https://mahmoudsafaya.github.io/redStore/",
    image: "images/project-11.png",
  },
];

export { HomeProjects, PortfolioProjects };
